import React from "react";
// import errorJson from "../../../LittieJson/pageError.json";
import cx from "classnames";
import styles from "./ServerError.module.css";
// import { Controls, Player } from "@lottiefiles/react-lottie-player";
import Link from "next/link";

const ServerError = ({ prevPageLink }) => {
  return (
    <div
      className={cx(
        styles.container,
        "d-flex",
        "flex-column",
        "align-items-center",
        "justify-content-center",
        "position-fixed"
      )}
    >
      {/* <Player autoplay loop src={errorJson} style={{ height: "150px" }}>
        <Controls
          visible={false}
          buttons={["play", "repeat", "frame", "debug"]}
        />
      </Player> */}
      <h2 className={cx(styles.title, "my-4")}>خطای ارتباط با سرور</h2>

      <button
        className={cx(
          styles.backBtnStyles,
          "d-flex",
          "align-items-center",
          "justify-content-center",
          "rounded-pill"
        )}
      >
        <Link
          target="_top"
          className="text-white"
          href={prevPageLink ? `${prevPageLink}` : "/"}
        >
          بازگشت به صفحه قبل
        </Link>
      </button>
    </div>
  );
};

export default ServerError;
